import './assets/styles/images.scss'
import imageTemplate from './assets/templates/images.mst'
import jQuery from 'jquery'

import modalController from '../modal'

/**
 * This action show inline an image inside the widget and display a modal when the image is clicked.
 * The content of the modal is the image and the title.
 * @param {Object} event - The emitted event
 * @param {Object} widget - The widget object
 * @param {Object} params - Contain the image source and title to render
 * @param {string} params.title - The modal's title
 * @param {string} params.source - The link of the image
 */
function action (event, widget, params) {
  // Render the image template
  let imageElement = jQuery(jQuery.mustache(imageTemplate, {
    title: params.title,
    source: params.source,
    sender: 'assistant'
  }))
  let modal = modalController.create()
  widget._input.focus()
  // Log the image element in the widget and focus it (scroll)
  let imageContent = imageElement.find('.wgt-action-image-content-img')
  imageContent.on('load', function () {
    widget._log(imageElement)
  })
  imageElement.on('click', function (event) {
    modalController.replaceContent({
      content: imageContent.prop('outerHTML'),
      title: params.title
    })
    modal.show()
  })
}
export default action
